import { Phone, Mail, Facebook, Instagram, ArrowRight } from "lucide-react";
import { site } from "@/data/site";

export default function ContactCta({ title, subtitle }) {
    return (
        <section
            data-testid="contact-cta"
            className="py-20 sm:py-28 bg-[var(--ns-text)] text-white relative overflow-hidden"
        >
            <div
                className="absolute inset-0 opacity-[0.07] pointer-events-none"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 20% 20%, #0A2A6B 0, transparent 50%), radial-gradient(circle at 80% 80%, #D4A373 0, transparent 50%)",
                }}
            />
            <div className="container-ns relative">
                <div className="max-w-3xl">
                    <div className="overline !text-white/60 mb-4">
                        Lad os tage en snak
                    </div>
                    <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter mb-5 leading-[1.05]">
                        {title || "Klar til dit næste projekt?"}
                    </h2>
                    <p className="text-white/75 text-lg leading-relaxed mb-10 max-w-2xl">
                        {subtitle ||
                            "Jeg Nicklas Sørensen kommer gerne ud og tager en snak om jeres projekt — helt uforpligtende."}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    <a
                        href={site.phoneHref}
                        data-testid="cta-call"
                        className="group bg-[var(--ns-blue)] hover:bg-[var(--ns-blue-dark)] transition p-7 rounded-md flex items-start justify-between"
                    >
                        <div>
                            <div className="overline !text-white/70 mb-2">
                                Ring direkte
                            </div>
                            <div className="font-display font-extrabold text-2xl tracking-tight">
                                {site.phone}
                            </div>
                        </div>
                        <div className="w-11 h-11 rounded-full bg-white/15 grid place-items-center group-hover:bg-white/25 transition">
                            <Phone className="w-5 h-5" />
                        </div>
                    </a>

                    <a
                        href={site.emailHref}
                        data-testid="cta-email"
                        className="group bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 transition p-7 rounded-md flex items-start justify-between"
                    >
                        <div>
                            <div className="overline !text-white/70 mb-2">
                                Skriv en mail
                            </div>
                            <div className="font-display font-extrabold text-lg tracking-tight break-all">
                                {site.email}
                            </div>
                        </div>
                        <div className="w-11 h-11 rounded-full bg-white/10 grid place-items-center group-hover:bg-white/20 transition">
                            <Mail className="w-5 h-5" />
                        </div>
                    </a>

                    <a
                        href={site.facebookUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-facebook"
                        className="group bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 transition p-7 rounded-md flex items-start justify-between"
                    >
                        <div>
                            <div className="overline !text-white/70 mb-2">
                                Følg på Facebook
                            </div>
                            <div className="font-display font-extrabold text-lg tracking-tight">
                                Facebook
                            </div>
                            <div className="text-sm text-white/60 mt-1 inline-flex items-center gap-1">
                                Se seneste arbejde{" "}
                                <ArrowRight className="w-3.5 h-3.5" />
                            </div>
                        </div>
                        <div className="w-11 h-11 rounded-full bg-white/10 grid place-items-center group-hover:bg-white/20 transition">
                            <Facebook className="w-5 h-5" />
                        </div>
                    </a>

                    <a
                        href={site.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-instagram"
                        className="group bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 transition p-7 rounded-md flex items-start justify-between"
                    >
                        <div className="min-w-0">
                            <div className="overline !text-white/70 mb-2">
                                Følg på Instagram
                            </div>
                            <div className="font-display font-extrabold text-lg tracking-tight">
                                Instagram
                            </div>
                            <div className="text-xs text-white/60 mt-1 inline-flex items-center gap-1 truncate">
                                @ns_tomrer_ejendomsservive{" "}
                                <ArrowRight className="w-3.5 h-3.5 flex-shrink-0" />
                            </div>
                        </div>
                        <div className="w-11 h-11 rounded-full bg-white/10 grid place-items-center group-hover:bg-white/20 transition flex-shrink-0">
                            <Instagram className="w-5 h-5" />
                        </div>
                    </a>
                </div>
            </div>
        </section>
    );
}
